// import {fetchAccount} from '@/devicehq/api/account'
import {DEVICEHQ} from '@/devicehq/api'

const getAccount = context => {
  // fetchAccount
  DEVICEHQ.get('/api/v2/account', {
    data: {},
  })
    .then(response => {
      context.commit('ACCOUNT_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

export default {
  getAccount,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/account/actions.js